import { Breadcrumb } from 'components/breadcrumb'
import { PecSwitch, PrivateRoute } from 'components/route'
import { Fragment } from 'react'
import { useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions'

import { CidadaoCreateView } from './create/CidadaoCreateView'
import { CidadaoEditView } from './create/CidadaoEditView'
import { CidadaoListView } from './listagem/CidadaoListView'
import { CidadaoVisualizacaoView } from './visualizacao/CidadaoVisualizacaoView'
import { visualizarCidadaoAndProntuarioPermissions } from './visualizacao/types/model-cidadaoTabSection'

export function CidadaoRootView() {
  const match = useRouteMatch()

  return (
    <Fragment>
      <Breadcrumb title='Cadastro individual' />
      <PecSwitch>
        <PrivateRoute
          path={`${match.url}/create`}
          component={CidadaoCreateView}
          permission={Permissions.gestaoDeCadastros.visualizarCadastroIndividual.cadastrarEEditar}
        />
        <PrivateRoute
          exact
          path={`${match.url}/:cidadaoId(\\d+)/edit`}
          component={CidadaoEditView}
          permission={Permissions.gestaoDeCadastros.visualizarCadastroIndividual.cadastrarEEditar}
        />
        <PrivateRoute
          exact
          path={`${match.url}`}
          component={CidadaoListView}
          permission={Permissions.gestaoDeCadastros.visualizarCadastroIndividual}
        />
        <PrivateRoute
          path={`${match.url}/:cidadaoId(\\d+)`}
          component={CidadaoVisualizacaoView}
          permission={visualizarCidadaoAndProntuarioPermissions}
        />
      </PecSwitch>
    </Fragment>
  )
}
